<template>
    <a :href="prepareJobUrl(job.absolute_url)">
        <div class="item uk-card uk-card-position uk-flex uk-flex-column uk-flex-left uk-flex-top">
            <div class="department uk-badge uk-badge-orange uk-margin-xsmall-bottom" :title="departmentName">
                {{ departmentName }}
            </div>
            <div class="uk-card-title role uk-h5 uk-margin-xsmall-top uk-margin-xsmall-bottom" :title="job.title">{{ job.title }}</div>

            <div class="location uk-margin-auto-top ">
                <span
                   class="uk-text-with-bullet -black -xsmall"
                    :title="locationsText"
                    >{{ locationsText }}</span
                >
                
            </div>
        </div>
    </a>
</template>

<script>
export default {
    name: "job-item",
    props: ["job", "deptName"],
    data() {
        return {};
    },
    computed: {
        departmentName() {
            return this.deptName || this.job.JobFamily;
        },
        locations: function () {
            if (Object.keys(this.job.Locations).length == 1) {
                return [this.job.Locations[Object.keys(this.job.Locations)[0]].name];
            } else if (Object.keys(this.job.Locations).length > 1 && Object.keys(this.job.Locations).length < 3) {
                return Object.values(this.job.Locations).map((l) => l.name);
            } else {
                return [
                  this.$tc("message.multiple_locations", Object.values(this.job.Locations).length),
                ];
            }
        },
        locationsText: function() {
        if (Array.isArray(this.locations)) {
          return this.locations.join(' | ');
        }
        return '';
      }
    },
    methods: {
        prepareJobUrl(url) {
            // Ensure the 'open-positions' part exists in the URL
            if (!url.includes('/open-positions')) {
                return url.replace('/careers/', '/careers/open-positions/');
            }
            return url;
        },
    },
};
</script>
